// BlockWrapper.tsx
// A reusable wrapper component for consistent global styling using Tailwind tokens
import React from 'react'

interface BlockWrapperProps {
  children: React.ReactNode
  className?: string
}

const BlockWrapper: React.FC<BlockWrapperProps> = ({ children, className = '' }) => (
  <section
    className={`bg-background text-primary rounded-lg transition-all duration-300 ${className}`}
  >
    {children}
  </section>
)

export default BlockWrapper
